import { ReactNode } from 'react';
import { DNDContainer } from './DNDContainer';

export type ContainerType = 'main' | 'available';

export interface IGroupListItem {
	id: string;
	title: string;
	position: number;
	listId?: string;
}

export interface DNDContainerProps extends React.BaseHTMLAttributes<HTMLDivElement> {
	isLoading?: boolean;
	vertical?: boolean;
	isNotExclude?: boolean;

	list: Array<IGroupListItem>;
	availableListItems: Array<IGroupListItem>;
	mainListTitle?: string;
	availableListTitle?: string;

	searchEnable?: boolean;
	renderToolbar?: (
		type: ContainerType,
		item: IGroupListItem,
		scrollPosition: any,
	) => ReactNode;
	onChangeList?: (
		type: 'add' | 'remove' | 'position',
		list: Array<string>,
		item?: IGroupListItem,
	) => void;
}

export default DNDContainer;
